import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@material-tailwind/react";
import {
  faBuilding,
  faBullseye,
  faCity,
  faMap,
} from "@fortawesome/free-solid-svg-icons";
import Queries from "../../utils/queries";
import Subtitle from "../Subtitle";
import {
  statisticsLabel,
  selectorLabel,
  dashboardStyle,
} from "../Statistics/SommaireStatisticsStyle";
import { UsefullList } from "../Statistics/UsefullList";
import Mapping from "../../utils/mapping";
import _ from "lodash";
import { useTranslation } from "react-i18next";

const StatisticsFilter = ({
  onDepartementChange,
  onVilleChange,
  onSecteurChange,
  onDomaineChange,
  selectedDepartement,
  selectedVille,
  selectedDomaine,
  selectedSecteur,
}) => {
  const [departements, setDepartments] = useState([]);
  const [villes, setVilles] = useState([]);
  const [domaines, setDomaines] = useState([]);
  const [secteurs, setSecteurs] = useState([]);
  const [departementFilter, setDepartmentFilter] =
    useState(selectedDepartement);
  const [villeFilter, setVilleFilter] = useState(selectedVille);

  const [visibleCities, setVisibleCities] = useState([]);

  const checkScroll = () => {
    const isPC = window.matchMedia("(min-width: 960px)").matches;
    if (!isPC) return;

    const distanceFromTop = 750; // Convertir 15em en pixels (supposant que 1em = 16px)
    if (window.scrollY >= distanceFromTop) {
      document.getElementById("dashboard").classList.remove("relative");
      document.getElementById("dashboard").classList.add("fixed", "top-0");
      document.getElementById("dashboard").classList.add("w-1/5", "top-0");
    } else {
      document.getElementById("dashboard").classList.remove("fixed", "top-0");
      document.getElementById("dashboard").classList.remove("w-1/5");

      document.getElementById("dashboard").classList.add("relative");
    }
  };

  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener("scroll", checkScroll);
    return () => {
      window.removeEventListener("scroll", checkScroll);
    };
  }, []);

  function handleVilleChange(e) {
    const codeVille = e.target.value;
    const codeDepartement = villes.find(
      (v) => v.code == codeVille
    )?.departement;
    onVilleChange(codeVille);
    setDepartmentFilter(codeDepartement);
  }

  function handleDepartmentChange(e) {
    const codeDepartement = e.target.value;
    setVisibleCities(
      villes.filter((v) =>
        codeDepartement ? v.departement == codeDepartement : true
      )
    );
    setDepartmentFilter(codeDepartement);
    onVilleChange("");
    onDepartementChange(codeDepartement);
  }

  useEffect(() => {
    const datas = async () => {
      try {
        const responseDepartment = await Queries.departements();
        const listeDepartments = Mapping.departements(responseDepartment.data);
        setDepartments(listeDepartments);

        const responseVilles = await Queries.villes();
        const listeVilles = Mapping.villes(responseVilles.data);
        setVilles(listeVilles);
        setVisibleCities(listeVilles);

        const responseDomaines = await Queries.domaines();
        const listeDomaines = Mapping.domaines(responseDomaines.data);
        setDomaines(listeDomaines);

        const responseSecteurs = await Queries.secteurs();
        const listeSecteurs = Mapping.secteurs(responseSecteurs.data);
        setSecteurs(listeSecteurs);
      } catch (error) {
        if (error.response) {
          console.log(`error.response`);
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
        } else {
          console.log("Error", error.message);
        }
      }
    };
    datas();
  }, []);

  function reset() {
    setVilleFilter("");
    setDepartmentFilter("");
    onSecteurChange("");
    onDomaineChange("");
    onVilleChange("");
    onDepartementChange("");
  }

  return (
    <form id="dashboard" style={dashboardStyle}>
      <div className="mx-auto grid grid-cols-4">
        <div className="col-span-4">
          <Subtitle name="Filtre" />
        </div>

        <div className="col-span-4 pt-2 flex flex-row justify-between">
          <label
            htmlFor="departement"
            className="col-span-2 pt-2"
            style={statisticsLabel}
          >
            {" "}
            <FontAwesomeIcon icon={faMap} style={{ color: "green" }} />{" "}
            Départements{" "}
          </label>

          <select
            id="departement"
            style={selectorLabel}
            className="col-span-2"
            value={departementFilter}
            onChange={handleDepartmentChange}
          >
            <UsefullList data={departements} id="CODE_DEPARTEMENT" />
          </select>
        </div>

        <div className="col-span-4 pt-2 flex flex-row justify-between">
          <label
            htmlFor="ville"
            className="col-span-2 pt-2"
            style={statisticsLabel}
          >
            {" "}
            <FontAwesomeIcon
              icon={faCity}
              style={{ color: "brown" }}
            /> Villes{" "}
          </label>
          <select
            id="ville"
            style={selectorLabel}
            className="col-span-2"
            value={villeFilter}
            onChange={handleVilleChange}
          >
            <UsefullList data={visibleCities} id="CODE_VILLE" />
          </select>
        </div>

        <div className="col-span-4 pt-2 flex flex-row justify-between">
          <label
            htmlFor="secteur"
            className="col-span-2 pt-2"
            style={statisticsLabel}
          >
            <FontAwesomeIcon icon={faBuilding} style={{ color: "blue" }} />{" "}
            Secteurs
          </label>
          <select
            id="secteur"
            style={selectorLabel}
            value={selectedSecteur}
            className="col-span-2"
            onChange={(e) => onSecteurChange(e.target.value)}
          >
            <UsefullList data={secteurs} id="CODE_SECTEUR" />
          </select>
        </div>

        <div className="col-span-4 pt-2 flex flex-row justify-between">
          <label
            htmlFor="domaine"
            className="col-span-2 pt-2"
            style={statisticsLabel}
          >
            {" "}
            <FontAwesomeIcon icon={faBullseye} style={{ color: "red" }} />{" "}
            Domaines{" "}
          </label>
          <select
            id="domaine"
            style={selectorLabel}
            value={selectedDomaine}
            className="col-span-2 form-control"
            onChange={(e) => onDomaineChange(e.target.value)}
          >
            <UsefullList data={domaines} id="CODE_DOMAINE" />
          </select>
        </div>

        <span className="col-span-2 pt-2" style={statisticsLabel}></span>
        <Button
          variant="outlined"
          color="blue"
          size="sm"
          className="col-span-2 my-2"
          onClick={reset}
        >
          {t("button.reset")}
        </Button>
      </div>
      <div className="w-11/12 mx-auto grid grid-cols-4 hidden lg:grid"></div>
    </form>
  );
};

export default StatisticsFilter;
